// Copia ESM de ventas/scrap/televenta_email_template.js (CommonJS, usado para el envío
// real por Resend) — mismo contenido, SOLO para que EmailPreviewModal renderice el HTML
// real que recibe el lead (mismas URLs de S3, mismo CTA a la landing). Mantener en sync
// si se cambia el copy/diseño en uno de los dos sitios.

const SECTOR_LABEL = {
  peluquerias: "peluquería",
  barberia: "barbería",
  estetica: "clínica estética",
  lavadero: "lavadero",
  comida_para_llevar: "negocio de comida para llevar",
  taller: "taller",
  canina: "peluquería canina",
  tatuajes: "estudio de tatuajes",
  fisioterapia: "consulta",
  autoescuela: "autoescuela",
};

const LANDING_SLUG = {
  peluquerias: "peluqueria",
  barberia: "barberia",
  estetica: "estetica",
  lavadero: "lavadero",
  comida_para_llevar: "comidas",
  taller: "talleres",
  canina: "peluqueria-canina",
  tatuajes: "tatuajes",
  fisioterapia: "fisioterapia",
  autoescuela: "autoescuelas",
};

const SUBJECT_BY_SECTOR = {
  peluquerias: "La app que gestiona tu peluquería (citas, recordatorios y factura) 💇",
  barberia: "La app que gestiona tu barbería (citas, recordatorios y factura) 💈",
  estetica: "La app que gestiona tu clínica estética (citas, recordatorios y factura) ✨",
  lavadero: "La app que gestiona tu lavadero (citas, recordatorios y factura) 🚗",
  comida_para_llevar: "Vende más por WhatsApp sin llamadas ni apps que descargar 🍔",
  taller: "Que tus clientes te pidan cita por WhatsApp (y dejen de llamarte) 🔧",
  canina: "Que tus clientes pidan cita para su perro por WhatsApp 🐶",
  tatuajes: "Deja de perder mañanas por los que no aparecen 🎨",
  fisioterapia: "Que tus pacientes pidan cita por WhatsApp (y no falten) 💪",
  autoescuela: "Tus alumnos confirman la práctica con un botón (y el hueco del que falla no se pierde) 🚗",
};

const BODY_BULLETS_BY_SECTOR = {
  peluquerias: [
    "📋 Controla la cita, el servicio a prestar, tiempos de procesamiento y exposición.",
    "📱 Crea citas online y confírmalas por WhatsApp.",
    "🔔 Recordatorios de citas por WhatsApp, con un 90% de lectura garantizado.",
    "💻 Facturación integrada y adaptada a VeriFactu, sin más costes ni programas aparte.",
    "⏰ Control horario de trabajadores.",
  ],
  barberia: [
    "📋 Controla la cita, el servicio a prestar, tiempos de procesamiento y exposición.",
    "📱 Crea citas online y confírmalas por WhatsApp.",
    "🔔 Recordatorios de citas por WhatsApp, con un 90% de lectura garantizado.",
    "💻 Facturación integrada y adaptada a VeriFactu, sin más costes ni programas aparte.",
    "⏰ Control horario de trabajadores.",
  ],
  estetica: [
    "📋 Controla la cita, el servicio a prestar, tiempos de procesamiento y exposición.",
    "📱 Crea citas online y confírmalas por WhatsApp.",
    "🔔 Recordatorios de citas por WhatsApp, con un 90% de lectura garantizado.",
    "💻 Facturación integrada y adaptada a VeriFactu, sin más costes ni programas aparte.",
    "⏰ Control horario de trabajadores.",
  ],
  lavadero: [
    "📋 Controla la cita, el tipo de lavado a realizar, y ajusta tiempo y precio al tipo de coche de tu cliente.",
    "📱 Crea citas online inmediatas y confírmalas por WhatsApp.",
    "🔔 Recordatorios de citas por WhatsApp, con un 90% de lectura garantizado.",
    "💻 Facturación integrada y adaptada a VeriFactu, sin más costes ni programas aparte.",
    "⏰ Control horario de trabajadores.",
  ],
  comida_para_llevar: [
    "📲 Publica tu menú por WhatsApp y aumenta tus ventas.",
    "🍔 Tus clientes te piden automáticamente por WhatsApp, sin llamadas ni apps que descargar.",
    "🍽️ Publicita tu plato del día y llega a toda tu clientela al instante.",
    "🔔 Recordatorio de recogida por WhatsApp, con un 90% de lectura garantizado.",
    "💻 Facturación integrada y adaptada a VeriFactu, sin más costes ni programas aparte.",
    "⏰ Control horario de trabajadores.",
  ],
  taller: [
    "📱 Tus clientes te piden cita por WhatsApp, solos y a cualquier hora, sin llamadas ni apps que descargar.",
    "✅ Confirmación al momento y recordatorio antes de la cita: se acabaron los que no aparecen.",
    "🔔 Avisa del estado del coche por WhatsApp (\"en reparación\", \"listo para recoger\") y deja de contestar lo mismo veinte veces al día.",
    "🔧 Recordatorio automático de la revisión y la ITV: tus clientes vuelven solos.",
    "📣 Campañas de marketing por WhatsApp a toda tu clientela, con un 90% de lectura.",
    "💻 Facturación integrada y adaptada a VeriFactu, y la factura también se envía por WhatsApp.",
    "⏰ Control horario de trabajadores.",
  ],
  canina: [
    "📱 Tus clientes piden cita para su perro por WhatsApp, solos y a cualquier hora, sin llamadas ni apps que descargar.",
    "✅ Confirmación al momento y recordatorio antes de la cita: se acabaron los que no aparecen.",
    "🐶 Ficha de cada perro: raza, tamaño, tipo de corte y notas del último baño.",
    "🔔 Aviso automático cuando toca repetir el baño: tus clientes vuelven solos, sin que persigas a nadie.",
    "📣 Campañas de marketing por WhatsApp a toda tu clientela, con un 90% de lectura garantizado.",
    "💻 Facturación integrada y adaptada a VeriFactu, y la factura también se envía por WhatsApp.",
  ],
  tatuajes: [
    "📱 Tus clientes reservan su sesión por WhatsApp, solos y a cualquier hora, sin perseguirte por Instagram.",
    "✅ Confirmación al momento y recordatorio antes de la sesión: se acabaron los que no aparecen.",
    "🎨 Ficha de cada cliente: diseños, sesiones anteriores, alergias y consentimientos firmados.",
    "🔔 Aviso automático del retoque y de la siguiente sesión: no se te queda ningún trabajo a medias.",
    "📣 Campañas de marketing por WhatsApp a toda tu clientela, con un 90% de lectura garantizado.",
    "💻 Facturación integrada y adaptada a VeriFactu, y la factura también se envía por WhatsApp.",
  ],
  fisioterapia: [
    "📱 Tus pacientes piden cita por WhatsApp, solos y a cualquier hora, sin llamadas ni apps que descargar.",
    "✅ Confirmación al momento y recordatorio antes de la sesión: cada hueco que se pierde son 45 minutos que no vuelven.",
    "📋 Nota de cada sesión y documentos del paciente, con la evolución siempre a mano.",
    "🎟️ Bonos de sesiones que se descuentan solos, y aviso antes de que caduquen.",
    "💻 Facturación integrada y adaptada a VeriFactu, con IVA exento si tu actividad lo es.",
    "⏰ Control horario de trabajadores.",
  ],
  // Autoescuela (9/9/2026). Espejo EXACTO de BULLETS_AUTOESCUELA en
  // admin_scripts/add_televenta_video_templates.js: quien reciba el WhatsApp y el correo
  // debe leer el mismo mensaje. Lo que NO se promete, porque no existe y un director lo
  // caza en cinco minutos (docs/features/autoescuela-inventario-completo.md §18): el
  // export AUES, los impresos oficiales de la DGT y que "el alumno reserva solo" — el
  // alumno CONFIRMA y, como mucho, PIDE; la agenda la sigue haciendo la autoescuela.
  autoescuela: [
    "📱 Tus alumnos confirman la práctica con un botón en WhatsApp, sin llamadas ni apps que descargar.",
    "🔄 Si uno cancela, el hueco se ofrece solo al resto por WhatsApp y se lo queda el primero que diga que sí.",
    "💸 La cancelación tardía se cobra sola — salvo si el hueco se rellena, y entonces no se cobra nada.",
    "📊 Panel de plantones: cuántos tienes y lo que te están costando al mes.",
    "📖 Libro de registro de alumnos del artículo 39, en PDF y en Excel, con la matrícula correlativa.",
    "🎓 Tasa de aprobados por profesor y por convocatoria: el dato con el que se elige autoescuela.",
    "💻 Facturación adaptada a VeriFactu, y la factura también se envía por WhatsApp.",
  ],
};

// Variante A/B "crecimiento": mismo producto (CRM), encuadre distinto ("además te traemos
// clientes" en vez de solo "te organiza la agenda"). Convive con el copy "gestion" de
// SUBJECT_BY_SECTOR/BODY_BULLETS_BY_SECTOR de arriba (no lo sustituye). Solo 4 sectores.
const CRECIMIENTO_SUBJECT_BY_SECTOR = {
  taller: "Que tus clientes vuelvan solos (y que Google te encuentre) 🔧",
  canina: "Que tus clientes vuelvan solos (y que Google te encuentre) 🐶",
  tatuajes: "Que tus clientes vuelvan solos (y que Google te encuentre) 🎨",
  fisioterapia: "Que tus pacientes vuelvan solos (y que Google te encuentre) 💪",
};

const CRECIMIENTO_INTRO_TEXT =
  "La mayoría de programas de citas se quedan en organizarte la agenda. Nosotros además te traemos clientes.";

const CRECIMIENTO_BODY_BULLETS_BY_SECTOR = {
  taller: [
    "🔁 Recupera a los que ya no vuelven: a quien hace un año que no pasa por el taller le llega solo el aviso de la revisión y la ITV.",
    "⭐ Más reseñas en Google: se las pedimos automáticamente después de cada cita, y tu ficha sube. Quien busca \"taller mecánico\" cerca, te encuentra a ti.",
    "🎂 Felicitaciones de cumpleaños con descuento opcional, que invitan a volver.",
    "📣 Campañas por WhatsApp a toda tu clientela cuando tú quieras, con un 90% de lectura.",
    "📱 Y además tus clientes piden cita por WhatsApp solos, y les avisas del estado del coche sin descolgar el teléfono.",
  ],
  canina: [
    "🔁 Recupera a los que ya no vuelven: a quien hace dos meses que no viene le llega solo un mensaje para que reserve otra vez.",
    "⭐ Más reseñas en Google: se las pedimos automáticamente después de cada cita, y tu ficha sube. Quien busca \"peluquería canina\" cerca, te encuentra a ti.",
    "🎂 Felicitaciones de cumpleaños con descuento opcional, que invitan a volver.",
    "📣 Campañas por WhatsApp a toda tu clientela cuando tú quieras, con un 90% de lectura.",
    "📱 Y además tus clientes piden cita por WhatsApp solos, con confirmación y recordatorio automáticos.",
  ],
  tatuajes: [
    "🔁 Recupera a los que ya no vuelven: a quien se quedó a medias le llega solo el aviso del retoque y de la siguiente sesión.",
    "⭐ Más reseñas en Google: se las pedimos automáticamente después de cada cita, y tu ficha sube. Quien busca \"estudio de tatuajes\" cerca, te encuentra a ti.",
    "🎂 Felicitaciones de cumpleaños con descuento opcional, que invitan a volver.",
    "📣 Campañas por WhatsApp a toda tu clientela cuando tú quieras, con un 90% de lectura.",
    "📱 Y además tus clientes piden cita por WhatsApp solos, con confirmación y recordatorio automáticos.",
  ],
  fisioterapia: [
    "🔁 Recupera a los que ya no vuelven: a quien terminó su tratamiento hace meses le llega solo un recordatorio de revisión.",
    "⭐ Más reseñas en Google: se las pedimos automáticamente después de cada cita, y tu ficha sube. Quien busca \"fisioterapeuta\" cerca, te encuentra a ti.",
    "🎂 Felicitaciones de cumpleaños con descuento opcional, que invitan a volver.",
    "📣 Campañas por WhatsApp a toda tu clientela cuando tú quieras, con un 90% de lectura.",
    "📱 Y además tus pacientes piden cita por WhatsApp solos, con confirmación y recordatorio automáticos.",
  ],
};

const MARKETING_SUBJECT_BY_SECTOR = {
  peluquerias: "Vídeos para traer clientes nuevos a tu peluquería 🎬",
  barberia: "Vídeos para traer clientes nuevos a tu barbería 🎬",
  estetica: "Vídeos para traer clientes nuevos a tu clínica estética 🎬",
  lavadero: "Vídeos para traer clientes nuevos a tu lavadero 🎬",
  comida_para_llevar: "Vídeos para traer más pedidos a tu negocio 🎬",
};

const MARKETING_BODY_BULLETS_BY_SECTOR = {
  peluquerias: [
    "🎥 Te generamos vídeos personalizados con tu logo, listos para enviar por WhatsApp.",
    "💇 Ideales para traer clientas nuevas o recuperar a las que ya no vienen.",
    "📲 Se envían desde TU propio WhatsApp Business, sin que nadie más aparezca.",
    "💳 Pagas solo por la campaña que envías, sin cuota fija.",
  ],
  barberia: [
    "🎥 Te generamos vídeos personalizados con tu logo, listos para enviar por WhatsApp.",
    "💈 Ideales para traer clientes nuevos o recuperar a los que ya no vienen.",
    "📲 Se envían desde TU propio WhatsApp Business, sin que nadie más aparezca.",
    "💳 Pagas solo por la campaña que envías, sin cuota fija.",
  ],
  estetica: [
    "🎥 Te generamos vídeos personalizados con tu logo, listos para enviar por WhatsApp.",
    "✨ Ideales para traer clientas nuevas o recuperar a las que ya no vienen a su tratamiento.",
    "📲 Se envían desde TU propio WhatsApp Business, sin que nadie más aparezca.",
    "💳 Pagas solo por la campaña que envías, sin cuota fija.",
  ],
  lavadero: [
    "🎥 Te generamos vídeos personalizados con tu logo, listos para enviar por WhatsApp.",
    "🚗 Ideales para traer coches nuevos o recuperar clientes que ya no vienen.",
    "📲 Se envían desde TU propio WhatsApp Business, sin que nadie más aparezca.",
    "💳 Pagas solo por la campaña que envías, sin cuota fija.",
  ],
  comida_para_llevar: [
    "🎥 Te generamos vídeos personalizados con tu logo, listos para enviar por WhatsApp.",
    "🍔 Ideales para traer clientes nuevos o recuperar a los que ya no piden.",
    "📲 Se envían desde TU propio WhatsApp Business, sin que nadie más aparezca.",
    "💳 Pagas solo por la campaña que envías, sin cuota fija.",
  ],
};

export function landingUrl(sector, variant = "gestion") {
  const slug = LANDING_SLUG[sector];
  const params = new URLSearchParams({
    utm_source: "email",
    utm_medium: "email",
    utm_campaign: "televenta",
    utm_content: sector,
    utm_term: variant,
  });
  return `https://conextcrm.es/${slug}/?${params.toString()}`;
}

export function subjectForSector(sector, product = "crm", variant = "gestion") {
  if (product === "marketing") return MARKETING_SUBJECT_BY_SECTOR[sector] || "Vídeos para traer más clientes a tu negocio";
  if (variant === "crecimiento") return CRECIMIENTO_SUBJECT_BY_SECTOR[sector] || SUBJECT_BY_SECTOR[sector] || "La app que gestiona tu negocio";
  return SUBJECT_BY_SECTOR[sector] || "La app que gestiona tu negocio";
}

const ASSETS_BASE = "https://conextcrm-uploads.s3.eu-north-1.amazonaws.com/shared-assets/email";
const VIDEO_BASE = "https://conextcrm-uploads.s3.eu-north-1.amazonaws.com/shared-assets/flow";
export const LOGO_URL = `${ASSETS_BASE}/logo.png`;
export function heroUrlForSector(sector) {
  return `${ASSETS_BASE}/hero_${sector}.jpg`;
}
const NO_VIDEO_SECTORS = new Set(["taller", "canina", "tatuajes", "fisioterapia", "autoescuela"]);
export function videoUrlForSector(sector) {
  if (NO_VIDEO_SECTORS.has(sector)) return null; // sin vídeo: el hero es el póster, sin enlace
  return `${VIDEO_BASE}/televenta_${sector}.mp4`;
}
export function marketingHeroUrlForSector(sector) {
  return `${ASSETS_BASE}/hero_marketing_${sector}.jpg`;
}
export function marketingVideoUrlForSector(sector) {
  return `${VIDEO_BASE}/marketing_televenta_${sector}.mp4`;
}
export function marketingLandingUrl(sector) {
  const params = new URLSearchParams({
    utm_source: "email", utm_medium: "email", utm_campaign: "marketing_televenta", utm_content: sector,
  });
  return `https://conextcrm.es/marketing-whatsapp/?${params.toString()}`;
}

// CTA a WhatsApp: el lead escribe al número central de Conext (la conversación entra en el
// CRM y queda atada al contacto, a diferencia de un móvil personal). El texto va
// prerrellenado con el sector para que quien atiende sepa de qué va antes de leer nada.
const WA_NUMERO = "34960600024";
function waUrlForSector(sector) {
  const label = SECTOR_LABEL[sector] || "negocio";
  const texto = `Hola, me interesa ConextCRM para mi ${label}. ¿Me contáis cómo funciona?`;
  return `https://wa.me/${WA_NUMERO}?text=${encodeURIComponent(texto)}`;
}

export function htmlForSector(sector, nombre, product = "crm", variant = "gestion") {
  const label = SECTOR_LABEL[sector] || "negocio";
  const isMarketing = product === "marketing";
  const isCrecimiento = !isMarketing && variant === "crecimiento" && !!CRECIMIENTO_BODY_BULLETS_BY_SECTOR[sector];
  const bullets = isMarketing
    ? (MARKETING_BODY_BULLETS_BY_SECTOR[sector] || [])
    : isCrecimiento
      ? CRECIMIENTO_BODY_BULLETS_BY_SECTOR[sector]
      : (BODY_BULLETS_BY_SECTOR[sector] || []);
  const cta = isMarketing ? marketingLandingUrl(sector) : landingUrl(sector, isCrecimiento ? "crecimiento" : "gestion");
  const waUrl = waUrlForSector(sector);
  const videoUrl = isMarketing ? marketingVideoUrlForSector(sector) : videoUrlForSector(sector);
  const logoDataUri = LOGO_URL;
  const heroDataUri = isMarketing ? marketingHeroUrlForSector(sector) : heroUrlForSector(sector);
  const introText = isMarketing
    ? `Te generamos vídeos como este, personalizados con tu logo, para que traigas clientes nuevos o recuperes a los que ya no vienen a tu <strong>${label}</strong>:`
    : isCrecimiento
      ? CRECIMIENTO_INTRO_TEXT
      : `Te presentamos la aplicación informática más avanzada para la gestión de tu <strong>${label}</strong>:`;
  const nombreSafe = (nombre || "").replace(/</g, "&lt;");

  const bulletsHtml = bullets
    .map(
      (b) => `
        <tr>
          <td style="padding:6px 0;font-size:15px;line-height:1.5;color:#33333d;font-family:Arial,Helvetica,sans-serif;">
            ${b}
          </td>
        </tr>`,
    )
    .join("");

  return `<!doctype html>
<html lang="es">
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <title>${subjectForSector(sector, product, variant)}</title>
  </head>
  <body style="margin:0;padding:0;background-color:#f2f4f8;font-family:Arial,Helvetica,sans-serif;">
    <div style="display:none;max-height:0;overflow:hidden;opacity:0;">
      La app para gestionar tu ${label}: citas por WhatsApp, recordatorios y facturación. Sin visitas, todo online.
    </div>
    <table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="background-color:#f2f4f8;padding:32px 12px;">
      <tr>
        <td align="center">
          <table role="presentation" width="600" cellpadding="0" cellspacing="0" style="max-width:600px;width:100%;background-color:#ffffff;border-radius:16px;overflow:hidden;box-shadow:0 4px 24px rgba(20,30,60,0.08);">

            <!-- Header -->
            <tr>
              <td style="padding:28px 32px 12px 32px;" align="left">
                <img src="${logoDataUri}" alt="ConextCRM" width="180" style="display:block;border:0;outline:none;" />
              </td>
            </tr>

            <!-- Hero: miniatura del vídeo enlazada al mp4; sin vídeo (taller), el póster sin enlace -->
            <tr>
              <td style="padding:8px 24px 0 24px;">
                ${videoUrl
                  ? `<a href="${videoUrl}" target="_blank" style="text-decoration:none;">
                  <img src="${heroDataUri}" alt="▶ Ver vídeo: ConextCRM para tu ${label}" width="552"
                       style="display:block;width:100%;max-width:552px;border-radius:12px;border:0;outline:none;" />
                </a>`
                  : `<img src="${heroDataUri}" alt="ConextCRM para tu ${label}" width="552"
                       style="display:block;width:100%;max-width:552px;border-radius:12px;border:0;outline:none;" />`}
              </td>
            </tr>

            <!-- Body -->
            <tr>
              <td style="padding:24px 32px 0 32px;font-family:Arial,Helvetica,sans-serif;">
                <p style="margin:0 0 14px 0;font-size:20px;line-height:1.4;color:#12131a;font-weight:bold;">
                  Hola, ${nombreSafe || "👋"} 👋
                </p>
                <p style="margin:0 0 18px 0;font-size:16px;line-height:1.5;color:#33333d;">
                  ${introText}
                </p>
              </td>
            </tr>

            <tr>
              <td style="padding:0 32px;">
                <table role="presentation" width="100%" cellpadding="0" cellspacing="0">
                  ${bulletsHtml}
                </table>
              </td>
            </tr>

            <tr>
              <td style="padding:20px 32px 0 32px;font-size:16px;line-height:1.5;color:#33333d;">
                ¿Quieres verlo funcionando con <strong>tu ${label}</strong> como ejemplo? Es una
                videollamada de 30 minutos, cuando a ti te venga bien.
              </td>
            </tr>

            <!-- CTA: abre WhatsApp con el mensaje escrito. La conversación entra en el CRM. -->
            <tr>
              <td style="padding:26px 32px 8px 32px;" align="center">
                <a href="${waUrl}" target="_blank"
                   style="display:inline-block;background:#25D366;color:#ffffff;
                          font-size:16px;font-weight:bold;text-decoration:none;padding:14px 30px;border-radius:10px;
                          font-family:Arial,Helvetica,sans-serif;">
                  💬 Me interesa — escríbenos por WhatsApp
                </a>
              </td>
            </tr>
            <tr>
              <td style="padding:6px 32px 4px 32px;font-size:13px;line-height:1.5;color:#7a7a85;" align="center">
                Al pulsar se abre nuestro WhatsApp con el mensaje ya escrito — solo tienes que darle a
                enviar. Tu especialista te responde hoy mismo y, si lo prefieres, puedes dejar la demo
                agendada tú mismo desde el propio chat.
              </td>
            </tr>
            <tr>
              <td style="padding:10px 32px 28px 32px;font-size:13px;line-height:1.5;color:#7a7a85;" align="center">
                <strong>PD:</strong> ¿prefieres el correo? Responde a este mismo email y te contactamos igual.
              </td>
            </tr>

            <!-- Footer -->
            <tr>
              <td style="padding:20px 32px 28px 32px;border-top:1px solid #eef0f4;">
                <p style="margin:0 0 6px 0;font-size:13px;color:#9a9aa5;font-family:Arial,Helvetica,sans-serif;">
                  Un saludo,<br />Equipo ConextCRM
                </p>
                <p style="margin:0;font-size:12px;color:#b3b3bd;font-family:Arial,Helvetica,sans-serif;">
                  ¿Dudas? Escríbenos a <a href="mailto:soporte@conextcrm.es" style="color:#9a9aa5;">soporte@conextcrm.es</a>
                  · <a href="https://conextcrm.es" style="color:#9a9aa5;">conextcrm.es</a>
                </p>
              </td>
            </tr>

          </table>
        </td>
      </tr>
    </table>
  </body>
</html>`;
}
